import {
  useMutation,
  UseMutationOptions,
} from '@tanstack/react-query';
import {
  CustomerPortalSessionRequest,
  CustomerPortalSessionResponse,
} from '@tinct/core-api-models';
import { ApiError, tinctApi } from '../../api';

export const createSubscriptionCancelSession = async (
  data: CustomerPortalSessionRequest,
): Promise<CustomerPortalSessionResponse> => {
  return await tinctApi.customerPortal.createSubscriptionCancelSession(data);
};

export const useCreateSubscriptionCancelSession = (
  options?: Omit<
    UseMutationOptions<CustomerPortalSessionResponse, ApiError, CustomerPortalSessionRequest>,
    'mutationFn'
  >,
) => {
  return useMutation<CustomerPortalSessionResponse, ApiError, CustomerPortalSessionRequest>({
    mutationFn: createSubscriptionCancelSession,
    ...options,
  });
};
